import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getResourceList } from '../../models/BaseModel'
import { ImageReplacementAnchor, FooterNavigation, SocialLinks, BlankErrorBoundry } from '@scrippsproduct/scripps-external-component-library'

import './../../scss/Footer.scss'

export default function Footer() {
    const [navSections, setNavSections] = useState([])
    const [socialLinks, setSocialLinks] = useState([])
    const {isSuccess, data} = useQuery(['footer', {resourceName: 'footer'}], getResourceList)

    useEffect(() => {
        if (isSuccess) {
            setNavSections(data.get('navSections'))
            setSocialLinks(data.get('socialLinks'))
        }
    }, [isSuccess, data])

    return (
        <footer className="main-footer">
            <content-constrainer>
                <div className="footer-logo">
                    <ImageReplacementAnchor href={`/`} 
                        image={{
                            url: 'https://ewscripps-brightspot-lower.s3.amazonaws.com/b5/63/73d728894ffe9c98564d5db1019d/ion-herologo-white.png', 
                            width: 1, 
                            height: 1
                        }} 
                        height={3.6}
                        baselineAdjustment={0.7}
                    />
                </div>
                <div className="footer-nav-wrapper">
                    { (isSuccess && navSections.length > 0) && 
                        <BlankErrorBoundry>
                            <FooterNavigation sections={navSections} />
                        </BlankErrorBoundry> 
                    }
                    { (isSuccess && socialLinks.length > 0) && 
                        <BlankErrorBoundry>
                            <SocialLinks size={1.5} showHeader={true} platforms={socialLinks}/>
                        </BlankErrorBoundry> 
                    }
                </div>
                <div className="copyright-notice">
                    {`© ${new Date().getFullYear()} ION Media Networks, all rights reserved. All third-party trademarks, including logos, are the property of their respective owners.`}
                </div>
            </content-constrainer>
        </footer>
    )
}
